import { AsyncPipe, NgIf } from "@angular/common";
import { ChangeDetectionStrategy, Component, inject } from "@angular/core";
import { MatIconModule } from "@angular/material/icon";
import { TranslocoModule } from "@ngneat/transloco";
import { AppConfigService } from "app/services/app-config.service";
import { ClientViewService } from "app/services/client-view.service";
import { Observable, combineLatest, map } from "rxjs";

/**
 * La banda de la vista de cliente (D-SET32): mientras un super admin mira como cliente, el marco lo dice
 * arriba y ofrece volver. Sin ella, quien la deja puesta acaba creyendo que le faltan datos.
 */
@Component({
    selector: "client-view-strip",
    standalone: true,
    imports: [AsyncPipe, NgIf, MatIconModule, TranslocoModule],
    templateUrl: "./client-view-strip.component.html",
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ClientViewStripComponent {
    private readonly clientView = inject(ClientViewService);
    private readonly appConfig = inject(AppConfigService);

    readonly visible$: Observable<boolean> = combineLatest([
        this.appConfig.config.pipe(map((config) => config?.role === "super-admin")),
        this.clientView.active$,
    ]).pipe(map(([superAdmin, active]) => superAdmin && active));

    backToInternal(): void {
        this.clientView.setRequested(false);
    }
}
